import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Map from '@strava/ui/Map';
import Polyline from '@strava/ui/Map/Polyline';
import Marker from '@strava/ui/Map/Marker';
import ElevationChart from '@strava/ui/ElevationChart';
import I18n from 'utils/I18n';

// Static Assets
import startMarker from '@strava/ui/Map/images/map-marker-start.png';
import rabbitMarker from '@strava/ui/Map/images/map-marker-rabbit.png';
import endMarker from '@strava/ui/Map/images/map-marker-end.png';

// Stylesheets
import styles from './styles.scss';
import 'mapbox-gl/dist/mapbox-gl.css';

const { MAPBOX_TOKEN } = process.env;

/*
The purpose of this wrapper is to provide both a Map and ElevationChart component
and this wrapper component will pass around an index that the user is hovering
on so that we can display the current point on the map based on where they're
hovering on the elevation chart.
*/

function MapElevationChartWrapper({ streams }) {
  const [rabbitIndex, setRabbitIndex] = useState(null);

  return (
    <>
      <Map
        APIToken={MAPBOX_TOKEN}
        latLng={streams.latlng}
        className={styles.map}
      >
        <Polyline latLng={streams.latlng} id="route-polyline" />

        <Marker latLng={streams.latlng[0]}>
          <img src={startMarker} alt="Route Start" className={styles.marker} />
        </Marker>

        <Marker latLng={streams.latlng.slice(-1)[0]}>
          <img src={endMarker} alt="Route End" className={styles.marker} />
        </Marker>

        {rabbitIndex && (
          <Marker latLng={streams.latlng[rabbitIndex]}>
            <img
              src={rabbitMarker}
              alt="Current Marker"
              className={styles.marker}
            />
          </Marker>
        )}
      </Map>

      <ElevationChart
        height={200}
        units={streams.unitSystem}
        elevation={streams.altitude}
        distance={streams.distance}
        onUpdateMarker={(index) => setRabbitIndex(index)}
        onMouseLeave={() => setRabbitIndex(null)}
        formatters={{
          ElevationFormatter(units) {
            return I18n.elevationFormatter(units);
          },
          DistanceFormatter(units) {
            return I18n.distanceFormatter(units);
          },
          PercentFormatter(units) {
            return I18n.percentFormatter(units);
          }
        }}
      />
    </>
  );
}

MapElevationChartWrapper.propTypes = {
  streams: PropTypes.shape({
    latlng: PropTypes.arrayOf(PropTypes.array).isRequired,
    altitude: PropTypes.arrayOf(PropTypes.number).isRequired,
    distance: PropTypes.arrayOf(PropTypes.number).isRequired,
    unitSystem: PropTypes.string.isRequired
  }).isRequired
};

export default MapElevationChartWrapper;
